<template>
  <span class="badge badge-pill mr-2 mb-3"
        :class="(isActive) ? 'badge-light-active' : 'badge-light'"
        @click="setActive">
    <i class="fas fa-check-circle fa-lg" v-if="isActive"></i> {{ topic | multiLangName }}
  </span>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      topic: Object
    },
    computed: {
      ...mapState('review', [
        'selectedPositiveTopics',
        'selectedNegativeTopics'
      ]),
      isActive () {
        const selectedRatingTopics = (this.topic.topic_type === 'positive') ? this.selectedPositiveTopics : this.selectedNegativeTopics
        return (selectedRatingTopics && selectedRatingTopics.indexOf(this.topic.id) !== -1)
      }
    },
    methods: {
      setActive () {
        this.$store.commit('review/SET_SELECTED_RATING_TOPICS', this.topic)
      }
    }
  }
</script>

<style scoped>
  .badge-light {
    background-color: #E0E0E0;
    padding: 0.75rem;
    font-weight: 400;
    cursor: pointer;
    font-size: 0.9rem;
  }

  .badge-light-active {
    background-color: #B2EBF2;
    color: #0097A7;
    padding: 0.75rem;
    font-weight: 400;
    cursor: pointer;
    font-size: 0.9rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/order/components/Chips.vue